<div class="container-fluid pb-4">
  <!-- HEADER (common for both types) -->
  <div class="row justify-content-between manageaccount mt-3">
    <div class="col-xl-12 col-12 col-sm-12 col-md-12 my-auto">
      <div class="d-flex align-items-baseline justify-content-between" style="margin-left: 2rem; margin-right: 2rem;">
        <h1 class="fs-4 fw-bold mb-0">Preview Invoice</h1>
        <div class="d-flex gap-2">
          <button class="btn btn-dark btn-sm" mat-raised-button (click)="declineInvoice()">Decline</button>
          <button class="btn btn-dark btn-sm" mat-raised-button (click)="approveInvoice()">Approve</button>
        </div>
      </div>

      <!-- <nav class="breadcrumbMaine" aria-label="breadcrumb mb-0">
                <ol class="breadcrumb mb-0">
                    <li class="breadcrumb-item" routerLink="/superAdmin/tracker">
                        Manage Tracker
                    </li>
                    <li class="breadcrumb-item active" aria-current="page">
                        View Tracker Invoice
                    </li>
                </ol>
            </nav> -->
    </div>
  </div>

  <!-- ================= TYPE 1 & TYPE 2 – Almost identical layout ================= -->
  <div class="row mt-3" *ngIf="showDefaultTable">
    <div class="col-xl-12">
      <div class="customContainerBox">
        <div class="row align-items-center mb-3">
          <!-- <button routerLink="../../gst-tracker-invoice/{{ paramId }}" mat-raised-button
                        class="btn btn-dark btn-sm px-4 me-2">
                        GST Invoice
                    </button>
                    <button mat-raised-button class="btn btn-dark btn-sm px-4" (click)="sendInvoice()">
                        Email
                    </button> -->
        </div>

        <!-- PRINTABLE INVOICE CONTENT -->
        <div class="NewInvoice" #printSection id="print-section">
          <table class="newInvoiceBox" style="width: 100%; border-collapse: collapse;">
            <!-- HEADER -->
            <tr>
              <td class="py-3">
                <table class="invoiceHead">
                  <tr>
                    <td>Transporter Name</td>
                    <td>: K LOGISTICS</td>
                  </tr>
                  <tr>
                    <td>Bill No.</td>
                    <td>: {{ billno }}</td>
                  </tr>
                </table>
              </td>
              <!-- <td class="text-end py-3">
                <img
                  src="../../../../assets/images/invoiceLogoDemo.png"
                  width="200"
                  alt="Company Logo"
                />
              </td> -->
            </tr>

            <!-- MAIN INVOICE TABLE -->
            <tr>
              <td colspan="2">
                <table class="invoiceDetails" *ngIf="users?.length > 0">
                  <thead>
                    <tr>
                      <td>Date</td>
                      <td>Tracker No.</td>
                      <td>VEHICLE NO</td>
                      <td>From</td>
                      <td>To</td>
                      <td>START READING</td>
                      <td>END READING</td>
                      <td>KMR.</td>
                      <td>EXTRA HRS</td>
                      <td>Toll & Parking</td>
                      <td>AMOUNT</td>
                    </tr>
                  </thead>

                  <tbody *ngFor="let user of users">
                    <tr *ngFor="let tracker of user.Tracker_no; let i = index">
                      <td>{{ user.date[i] | date:'dd-MM-yyyy' }}</td>
                      <td>{{ user.Tracker_no[i] }}</td>
                      <td>{{ user.vehicle_id[i] }}</td>
                      <td>{{ user.from[i] }}</td>
                      <td>{{ user.to[i] }}</td>
                      <td>{{ user.startmeterReading[i] }}</td>
                      <td>{{ user.endmeterReading[i] }}</td>
                      <td>{{ user.up_down_km[i] }}</td>
                      <td>{{ user.extrahour[i] }}</td>
                      <td>{{ user.tooltaxPaid[i] }}</td>
                      <td>{{ user.vehicleRate[i] | number:'1.2-2' }}</td>
                    </tr>

                    <!-- TOTAL ROW -->
                    <tr class="total-row">
                      <td class="footer">TOTAL</td>
                      <td class="footer"></td>
                      <td class="footer"></td>
                      <td class="footer"></td>
                      <td class="footer"></td>
                      <td class="footer"></td>
                      <td class="footer"></td>
                      <td class="footer">{{ kmtot | number:'1.2-2' }}</td>
                      <td class="footer">{{ extrahour | number:'1.2-2' }}</td>
                      <td class="footer">{{ tooltaxPaidtot | number:'1.2-2' }}</td>
                      <td class="footer">{{ invtot | number:'1.2-2' }}</td>
                    </tr>

                    <!-- SUMMARY (right side) -->
                    <tr>
                      <td colspan="7"></td>
                      <td colspan="4" class="p-0">
                        <table class="extraText">
                          <tr>
                            <td>Total KM = {{ kmtot | number:'1.2-2' }}</td>
                          </tr>
                          <tr>
                            <td>Extra Hours = {{ extrahour | number:'1.2-2' }}</td>
                          </tr>
                          <tr>
                            <td>Toll & Parking = {{ tooltaxPaidtot | number:'1.2-2' }}</td>
                          </tr>
                          <tr>
                            <td><strong>Total = {{ invtot | number:'1.2-2' }}</strong></td>
                          </tr>
                        </table>
                      </td>
                    </tr>

                    <!-- Amount in Words -->
                    <tr>
                      <td colspan="11" class="text-start pt-3">
                        <strong>In Words: {{ invtot | amountInWords }}</strong>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>

            <!-- CONFIRMATION TEXT -->
            <tr>
              <td colspan="2" class="pt-4">
                <p style="font-style: italic; text-align: center;">
                  We hereby confirm that all tracker entries duly acknowledged by the customer have
                  been received and the above details are correct.
                </p>
              </td>
            </tr>

            <!-- SIGNATURES -->
            <tr>
              <td colspan="2" class="pt-5">
                <table class="signature" style="width: 100%;">
                  <tr>
                    <td style="width: 33%; text-align: center;">
                      <p>Prepared By</p>
                      <p>___________________</p>
                      <p>Name & Designation</p>
                    </td>
                    <td style="width: 33%; text-align: center;">
                      <p>Verified By</p>
                      <p>___________________</p>
                      <p>Name & Designation</p>
                    </td>
                    <td style="width: 33%; text-align: center;">
                      <p>Approved By</p>
                      <p>___________________</p>
                      <p>Name & Designation</p>
                    </td>
                  </tr>
                </table>
              </td>
            </tr>
          </table>
        </div>

      </div>
    </div>
  </div>

  <!-- ================= Fixed Rate Invoice ================= -->
  <div class="row mt-3" *ngIf="showFixedRateTable">
    <div class="col-xl-12">
      <div class="customContainerBox">
        <div class="row align-items-center mb-3">
        </div>
        <div class="NewInvoice-table table-responsive" #printSection id="print-section">
          <div class="invoice-wrapper">
            <table class="newInvoiceBox"
              style="width: 100%; border-collapse: collapse; border: 1px solid #000; font-size: 12px;">
              <!-- TOP INFO -->
              <tr>
                <td colspan="18" class="newtable">
                  <table style="width: 100%; border-collapse: collapse;">
                    <tr>
                      <td style="border: 1px solid #000; padding: 6px; width: 20%;"><strong>Name of
                          Transporter:</strong></td>
                      <td colspan="5" style="border: 1px solid #000; padding: 6px;width: 80%;">Radha Swami</td>
                    </tr>
                    <tr>
                      <td style="border: 1px solid #000; padding: 6px; width: 20%;"><strong>DC No:</strong></td>
                      <td style="border: 1px solid #000; padding: 6px; width: 80%;">{{
                        getTopDisplayValue(users?.[0]?.dcNo?.[0]) }}</td>
                    </tr>
                    <tr>
                      <td style="border: 1px solid #000; padding: 6px; width: 20%;"><strong>Location:</strong></td>
                      <td style="border: 1px solid #000; padding: 6px; width: 80%;">{{
                        getTopDisplayValue(users?.[0]?.location?.[0]) }}</td>
                    </tr>
                    <tr>
                      <td style="border: 1px solid #000; padding: 6px; width: 20%;"><strong>Month:</strong></td>
                      <td style="border: 1px solid #000; padding: 6px; width: 80%;">{{
                        getTopDisplayValue(users?.[0]?.month?.[0]) }}</td>
                    </tr>

                    <tr>
                      <td style="border: 1px solid #000; padding: 6px; width: 20%;"><strong>Invoice No:</strong></td>
                      <td colspan="2" style="border: 1px solid #000; padding: 6px; width: 80%;">{{ billno || 'N/A' }}
                      </td>
                    </tr>
                    <tr>
                      <td style="border: 1px solid #000; padding: 6px; width: 20%;border-bottom: 0;"><strong>Invoice
                          Date (DD MMMM, YYYY)</strong></td>
                      <td colspan="2" style="border: 1px solid #000; padding: 6px; width: 80%; border-bottom: 0;">{{
                        getTopDisplayValue(users?.[0]?.invoiceDate?.[0]) }}</td>
                    </tr>
                  </table>
                </td>
              </tr>
              <tr>
                <td class="newtable-row">
                  <table>
                    <!-- HEADER -->
                    <thead>
                      <tr>
                        <th rowspan="2">SL No</th>
                        <th rowspan="2">Vehicle No</th>
                        <th rowspan="2">Capacity of Vehicle</th>
                        <th rowspan="2">No of Working Days</th>
                        <th rowspan="2">Actual Working Days</th>
                        <th rowspan="2">Fixed Km</th>
                        <th rowspan="2">Total Km</th>
                        <th rowspan="2">Extra Km</th>
                        <th rowspan="2">Extra Km Cost</th>
                        <th rowspan="2">Extra Hrs</th>
                        <th rowspan="2">Variable Cost per Hr</th>
                        <th rowspan="2">Fixed Amount</th>
                        <th colspan="1">Fixed Amt per Month</th>
                        <th colspan="1">Amount for KM</th>
                        <th colspan="1">Amount for Extra Hrs</th>
                        <th colspan="1">Toll/Parking chgs</th>
                        <th colspan="1">Incentive for trips / Halting Charge</th>
                        <th rowspan="2">Total Amount <br>
                          A + B + C + D
                        </th>
                      </tr>
                      <tr>
                        <th>(A)</th>
                        <th>(B)</th>
                        <th>(C)</th>
                        <th>(D)</th>
                        <th>(E)</th>
                      </tr>
                    </thead>

                    <!-- DATA ROWS -->
                    <tbody *ngFor="let user of users">
                      <tr *ngFor="let vehicle of user.vehicle_id; let i = index">
                        <td>{{ i + 1 }}</td>
                        <td>{{ getDisplayValue(user.vehicle_id?.[i]) }}</td>
                        <td>{{ getDisplayValue(user.vehicleType?.[i]) }}</td>
                        <td>28</td>
                        <td>{{ getActualWorkingDays(user.tripStartDate?.[i], user.tripEndDate?.[i]) }}</td>
                        <td>{{ getDisplayValue(user.fixedKM?.[i]) }}</td>
                        <td>{{ getDisplayValue(user.up_down_km?.[i]) }}</td>
                        <td>{{ getDisplayValue(getExtraKmVal(user, i)) }}</td>
                        <td>{{ getDisplayValue(user.extraKMCost?.[i]) }}</td>
                        <td>{{ getDisplayValue(user.extrahour?.[i]) }}</td>
                        <td>{{ getDisplayValue(user.variableCostHr?.[i]) }}</td>
                        <td>{{ getDisplayValue(user.fixedPayment?.[i]) }}</td>
                        <td>{{ getDisplayValue(user.fixedPaymentMonth?.[i]) }}</td>
                        <td>{{ getDisplayValue(getAmountForKm(user, i)) }}</td>
                        <td>{{ getDisplayValue(getAmountForExtraHrs(user, i)) }}</td>
                        <td>{{ getDisplayValue(user.tooltaxPaid?.[i]) }}</td>
                        <td>{{ getDisplayValue(user.otherPayment?.[i]) }}</td>
                        <td>{{ getDisplayValue(getRowTotalAmount(user, i)) }}</td>
                      </tr>

                      <!-- SUMMARY -->
                      <tr>
                        <td colspan="17" style="border: 1px solid #000; padding: 6px; text-align: left;">Total Dedicated
                          Vehicle
                          amount</td>
                        <td><strong>{{ getGrandTotal(users) > 0 ? (getGrandTotal(users) | number:'1.2-2') : '-'
                            }}</strong></td>
                      </tr>
                      <tr>
                        <td colspan="17" style="border: 1px solid #000; padding: 6px; text-align: left;"><strong>
                            Add:</strong> Man Power</td>
                        <td>-</td>
                      </tr>
                      <tr>
                        <td colspan="17" style="border: 1px solid #000; padding: 6px; text-align: left;"><strong>Add:
                          </strong>Flooring Charges</td>
                        <td>-</td>
                      </tr>
                      <tr>
                        <td colspan="17" style="border: 1px solid #000; padding: 6px; text-align: left;">Night operation
                          charges</td>
                        <td>-</td>
                      </tr>
                      <tr>
                        <td colspan="17" style="border: 1px solid #000; padding: 6px; text-align: left;">Additional
                          Labour</td>
                        <td>-</td>
                      </tr>
                      <tr>
                        <td colspan="17" style="border: 1px solid #000; padding: 6px; text-align: left;">
                          <strong>Less:</strong> Cash collection
                        </td>
                        <td>-</td>
                      </tr>
                      <tr style="background: #f2f2f2;">
                        <td colspan="17" style="border: 1px solid #000; padding: 6px; text-align: left;"><strong>Total
                            Payable</strong>
                        </td>
                        <td><strong>{{ getGrandTotal(users) > 0 ? (getGrandTotal(users) | number:'1.2-2') : '-'
                            }}</strong></td>
                      </tr>

                      <!-- FOOTER -->
                      <tr>
                        <td colspan="18" style="border: 1px solid #000; padding: 10px;">
                          We hereby confirmed that all the Invoice copies duly acknowledged by the customers have
                          received and above
                          details are found correct.
                        </td>
                      </tr>

                      <!-- SIGNATURE -->
                      <tr>
                        <td colspan="6" style="border: 1px solid #000; padding: 20px; text-align: center;">
                          <strong>Prepared By</strong><br><br>
                          Name<br>
                          Designation
                        </td>
                        <td colspan="6" style="border: 1px solid #000; padding: 20px; text-align: center;">
                          <strong>Verified By</strong><br><br>
                          Name<br>
                          Designation
                        </td>
                        <td colspan="6" style="border: 1px solid #000; padding: 20px; text-align: center;">
                          <strong>Authorized Signatory</strong><br><br>
                          Name<br>
                          Designation
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>

            </table>
          </div>
        </div>
      </div>
    </div>
  </div>


  <!-- HIDDEN PRINT BUTTON FOR ngxPrint (if you still use it) -->
  <button #printBtn ngxPrint printSectionId="print-section" style="display: none;"></button>

</div>